module.exports = __webpack_public_path__ + "img/shipping.476d4af9.svg";